import type { IPascoRepository } from "@src/domain/pascos/repository/pasco_repository";
import type { PascoDTO } from "../dto";
import { PascoDtoMapper } from "../mappers/pasco-dto.mapper";

/**
 * Use Case: Get PASCO by ID
 * Retrieves a specific PASCO record by its unique identifier
 */
export class GetPascoByIdUseCase {
    constructor(private readonly pascoRepository: IPascoRepository) { }

    /**
     * Execute the use case
     * @param pascoId - The unique identifier of the PASCO
     * @returns Promise<PascoDTO | null> - The PASCO DTO or null if not found
     * @throws Error if pascoId is invalid
     */
    async execute(pascoId: string): Promise<PascoDTO | null> {
        if (!pascoId || pascoId.trim() === '') {
            throw new Error('PASCO ID is required');
        }

        const pasco = await this.pascoRepository.getById(pascoId);
        return pasco ? PascoDtoMapper.toDTO(pasco) : null;
    }
}
